import './index.css'
import * as React from 'react'
import useScript from '@disco/utils/use-script'
import { RECAPTCHA_SITE_KEY } from '@disco/accounts/utils/config'

type Props = {
  onTokenReceived: (token: string) => any
  type: 'login' | 'signup'
  tokenRequests: number
}

const getToken = (action: string, callback: (token: string) => any) => {
  if (!window.grecaptcha) return
  window.grecaptcha.ready(function () {
    return window.grecaptcha
      .execute(RECAPTCHA_SITE_KEY, {
        action,
      })
      .then(callback)
  })
}

const switchCaptchaVisibility = (visibility: boolean) => {
  const elements = document.getElementsByClassName('grecaptcha-badge')

  if (elements.length) {
    const recaptcha = elements[0] as HTMLElement
    recaptcha.style.visibility = visibility ? 'visible' : 'hidden'
  }
}

const Recaptcha = ({ onTokenReceived, type, tokenRequests }: Props) => {
  const [loaded] = useScript(
    `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`,
  )
  React.useEffect(() => {
    if (!loaded) return
    getToken(type, (token: string) => onTokenReceived(token))
  }, [loaded, type, tokenRequests, onTokenReceived])
  React.useEffect(() => {
    switchCaptchaVisibility(true)
    return () => {
      switchCaptchaVisibility(false)
    }
  })
  return null
}

export default React.memo(Recaptcha)
